import {getRequest, postRequest} from '../fetchWrapper';

/**
 * Récupération de la liste des réseaux.
 *
 * @param string token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAdminNetworkList = (token, pageNumber, itemsPerPage, keywords) => {
    const url = `/api-v1/admin/network/${pageNumber}/${itemsPerPage}/${keywords}/list`
    return getRequest(url, token)
}

/**
 * Récupération des informations d'un réseau.
 *
 * @param string token Jeton d'authentification.
 * @param int id L'identifiant du réseau.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getNetworkInfos = (token, id) => {
    const url = `/api-v1/admin/network/${id}/infos`
    return getRequest(url, token)
}

/**
 * Récupération des informations de contact d'un réseau.
 *
 * @param string token Jeton d'authentification.
 * @param int id L'identifiant du réseau.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getNetworkContact = (token, id) => {
    const url = `/api-v1/admin/network/${id}/contact`
    return getRequest(url, token)
}

/**
 * Modification du statut d'un réseau.
 *
 * @param string token Jeton d'authentification.
 * @param object body Corps de la requête.
 */
export const updateNetworkStatus = (token, body) => {
    const url = `/api-v1/admin/network/enable`
    return postRequest(url, body, token)
}

/**
 * Modification des informations d'un réseau.
 *
 * @param string token Jeton d'authentification.
 * @param object body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateNetworkInfos = (token, body) => {
    const url = `/api-v1/admin/network/update`
    return postRequest(url, body, token)
}

/**
 * Modification des informations de contact d'un réseau.
 *
 * @param token Jeton d'authentification.
 * @param body Corps de la requête.
 * @return Response | null Réponse de la requête à l'API.
 */
export const updateNetworkContact = (token, body) => {
    const url = `/api-v1/admin/network/contact/infos`
    return postRequest(url, body, token)
}

/**
 * Modification du logo d'un réseau.
 *
 * @param token Jeton d'authentification.
 * @param body Corps de la requête.
 * @param id Identifiant du réseau.
 * @return Response | null Réponse de la requête à l'API.
 */
export const uploadNetworkLogo = (token, body, id) => {
    const url = `/api-v1/admin/network/${id}/logo`
    return postRequest(url, body, token);
}

/**
 * Suppression d'un réseau.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant du réseau.
 * @return Response | null Réponse de la requête à l'API.
 */
export const deleteNetworkFromDb = (token, id) => {
    const url = `/api-v1/admin/network/delete`
    return postRequest(url, id, token)
};